import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, Table, Carousel, Button } from 'react-bootstrap'
import axios from 'axios'
import swal from 'sweetalert'

import { handleErrorFetchingData } from '../../functions/errorHandling'
import getServerURL from '../../functions/getServerURL'

import FileUploader from '../file-uploading/FileUploader'

import DeliverableDocument from './DeliverableDocument'

class DeliverableDocumentsModal extends Component {

  state = {
    filesForUpload: [],
    carouselIndex: this.props.carouselIndex,
    carouselDirection: this.props.carouselDirection,
  }

  toggleUploadMode = (carouselIndex, carouselDirection) => {
    this.setState({ carouselIndex, carouselDirection })
  }

  handleFileDrop = (files) => {
    this.setState({ filesForUpload: [...this.state.filesForUpload, ...files] })
  }

  removeFileFromFilesToUpload = (file) => {
    const filesForUpload = this.state.filesForUpload.filter(fileToUpload => fileToUpload !== file)
    this.setState({ filesForUpload })
  }

  handleUploadAll = () => {
    const { filesForUpload } = this.state
    const { deliverable } = this.props

    swal({
      text: 'Your files are uploading. This may take a few moments',
      icon: require("../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })

    const uploadedFiles = filesForUpload.map(file => this.uploadFile(file))

    Promise.all(uploadedFiles)
    .then(files => {
      swal({
        title: "Success",
        text: "Your files were uploaded",
        icon: "success",
        button: "Continue",
      })
      const newFiles = files.map(file => file.data)
      this.props.addDeliverableDocument(deliverable.url, newFiles)
      this.setState({ filesForUpload: [] })
    })
  }


  handleFileUpload = (newFile) => {
    const { deliverable } = this.props

    swal({
      text: 'Your file is uploading. This may take a few moments',
      icon: require("../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })

    this.uploadFile(newFile)
    .then(response => {
      swal({
        title: "Success",
        text: "Your file was uploaded",
        icon: "success",
        button: "Continue",
      })
      const filesForUpload = this.state.filesForUpload.filter(file => file !== newFile)
      this.setState({ filesForUpload })
      this.props.addDeliverableDocument(deliverable.url, response.data)
    })
    .catch(error => {
      const message = "There was an error uploading your document"
      handleErrorFetchingData(error, message)
    })
  }


  uploadFile = (newFile) => {

    const { deliverable, documentRoute, currentUser } = this.props

    let fileToUpload = new FormData()

    fileToUpload.append('document', newFile)
    fileToUpload.append('name', newFile.name)
    fileToUpload.append('size', newFile.size)
    fileToUpload.append('deliverable', deliverable.url)
    fileToUpload.append('created_by', currentUser.url)

    return axios({
      method: "POST",
      url: `${getServerURL()}${documentRoute}/`,
      data: fileToUpload,
      headers: {"Authorization": "Bearer "+ localStorage.getItem("token")},
    })
  }


  deleteDocument = (documentUrl) => {
    axios({
      method: "DELETE",
      url: documentUrl,
      headers: {"Authorization": "Bearer "+ localStorage.getItem("token")}
    })
    .then(response => {
      this.props.deleteDeliverableDocument(documentUrl, this.props.deliverable.url)
    })
    .catch(error => {
      const message = "There was an error deleting your document"
      handleErrorFetchingData(error, message)
    })
  }

  render() {
    const { show, deliverable, documents, toggleShow } = this.props

    const { filesForUpload, carouselIndex, carouselDirection } = this.state

    return (
      <Modal
        id="DeliverableDocumentModal"
        show={show}
        onHide={toggleShow}
        bsSize="lg"
      >
        <Modal.Header>
          <Modal.Title>
            {`${deliverable.name} documents`}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Carousel
            interval={null}
            activeIndex={carouselIndex}
            direction={carouselDirection}
          >
            <Carousel.Item className="deliverable-document-modal-item">
              {deliverable.documents && documents.length > 0 ?
                <Table responsive condensed>
                  <thead>
                    <tr>
                      <td>Document</td>
                      <td>Size</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.map(doc => {
                      return (
                        <DeliverableDocument
                          key={doc.id}
                          deliverableDocument={doc}
                          deleteDocument={this.deleteDocument}
                        />
                      )
                    })}
                  </tbody>
                </Table>
                :
                <center id="no-documents">
                  <h4>No documents to display</h4>
                </center>
              }
            </Carousel.Item>

            <Carousel.Item className="deliverable-document-modal-item">
              <FileUploader
                allowMultiple={true}
                filesForUpload={filesForUpload}
                handleFileDrop={this.handleFileDrop}
                handleFileUpload={this.handleFileUpload}
                removeFile={this.removeFileFromFilesToUpload}
              />
              {filesForUpload.length > 0 ?
                <Button onClick={this.handleUploadAll}>
                  Upload All
                </Button>
                :
                null
              }
            </Carousel.Item>

          </Carousel>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={toggleShow}>
            Close
          </Button>
          {this.state.carouselIndex === 0 ?
            <Button
              bsStyle="primary"
              onClick={() => this.toggleUploadMode(1, 'next')}
            >
              Upload New Files
            </Button>
            :
            <Button
              bsStyle="primary"
              onClick={() => this.toggleUploadMode(0, 'prev')}
            >
              Show Uploaded Files
            </Button>
          }
        </Modal.Footer>

      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps)(DeliverableDocumentsModal)



// WEBPACK FOOTER //
// ./src/reuseable-components/deliverables/DeliverableDocumentsModal.js